export default __webpack_public_path__ + "static/media/Icon_read.1e3c9824.svg";